import React from 'react';
import {WidgetProps} from '../types';

const CompatibleDateTimeWidget: React.FC<WidgetProps> = ({}) => {
    return null;
};

export default CompatibleDateTimeWidget;
